let guideEffectTimeout = null;
import { driver } from "driver.js";

export function showGuideEffect() {
  clearTimeout(guideEffectTimeout); // 清理之前的定时器

  guideEffectTimeout = setTimeout(() => {
    const paths = document.querySelectorAll("path");
    const click = document.querySelector(".click_anime");
    const popover1 = document.querySelector(".prompt_box1");

    if (!paths.length || !click) return;

    paths.forEach((path) => {
      if (path) {
        path.classList.add("show-path");
      }
    });
    click.classList.add("isShow");

    // 优化隐藏效果
    if (popover1) {
      popover1.style.animation = "slideInFromRight 1s ease forwards"; // 应用从右向左的动画
    }
  }, 4000);
}
export function initializeGuide(elementId, indexClass) {
  const index = document.querySelector(`${indexClass}`);

  // 定义 driverHelper.js 的引导配置
  const driverObj = driver({
    allowClose: false,
    showProgress: true,
    steps: [
      {
        element: `${elementId}`, // 高亮的目标元素
      },
    ],
    onHighlightStarted: () => {
      const observer = new MutationObserver(() => {
        const highlightOverlay = document.querySelector(".driver-overlay");
        if (highlightOverlay && index) {
          const indexRect = index.getBoundingClientRect();
          // 使用 clip-path 定义遮罩区域
          highlightOverlay.style.clipPath = `inset(${indexRect.top}px ${
            window.innerWidth - indexRect.right
          }px ${window.innerHeight - indexRect.bottom}px ${indexRect.left}px)`;
          observer.disconnect();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    },
  });

  // 启动引导
  driverObj.drive();

  // 2秒后显示遮罩和手指
  showGuideEffect();

  return driverObj;
}

export function stopGuide(driverObj) {
  if (driverObj) {
    driverObj.destroy();
    const paths = document.querySelectorAll("path.show-path");
    paths.forEach((path) => path.classList.remove("show-path"));
    const click = document.querySelector(".click_anime");
    if (click) {
      click.classList.remove("isShow");
    }
  }
}
